import { Component } from '@angular/core';

@Component({
  selector: 'app-product-loading-tile',
  templateUrl: './product-loading-tile.component.html',
  styleUrls: ['./product-loading-tile.component.scss'],
})
export class ProductLoadingTileComponent {
}
